import { Button } from 'react-bootstrap';
import { FaChevronLeft } from 'react-icons/fa';
import { FormattedMessage } from 'react-intl';

function PreviousBtn({ onClick, className }) {
  return (
    <Button
      className={`d-flex justify-content-center align-items-center ${className || ''}`}
      variant="secondary"
      onClick={(e) => {
        if (onClick) {
          onClick(e);
        }
      }}>
      <FaChevronLeft className="me-2" />
      <FormattedMessage id="button.previous" />
    </Button>
  );
}

export default PreviousBtn;
